import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal, ModalFooter, ModalBody } from '../../../misc/modals'
import EmbedMaker from '../../../misc/embedMaker/EmbedMaker'
import { deleteVideo, editVideo } from '../../../actions'
import { getEmbedCode } from '../../../misc/utilities'
import './videoItem.css'
import GridItem from './GridItem'
import Cookies from 'js-cookie'
import ClipboardButton from 'react-clipboard.js'

class VideoItem extends Component {
  constructor() {
    super()
    this.state = {
      embedModalOpen: false,
      deleteModalOpen: false,
    }
    this.toggleEmbedModal = this.toggleEmbedModal.bind(this)
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this)
    this.toggleSelect = this.toggleSelect.bind(this)
    this.setState = this.setState.bind(this)
    this.editTitle = this.editTitle.bind(this)
    this.resetEmbed = this.resetEmbed.bind(this)
  }

  toggleEmbedModal() {
    this.setState({
      clipped: false,
      defaultsSaved: false,
      embedModalOpen: !this.state.embedModalOpen,
    })
    this.resetEmbed()
  }

  resetEmbed() {
    const video = this.props.video
    const embedOptions = {
      ...JSON.parse(Cookies.get('embed_options') || '{}'),
      ...this.props.me.embed_options,
    }
    this.setState({
      embedOptions,
    })
  }

  toggleDeleteModal() {
    this.setState({
      deleteModalOpen: !this.state.deleteModalOpen,
    })
  }

  editTitle(title, debounced) {
    this.props.dispatch(editVideo(this.props.video.shortcode, { title }, debounced))
  }

  toggleSelect() {
    if (this.props.selected) {
      this.props.onDeselect()
    } else {
      this.props.onSelect()
    }
  }

  render() {
    const self = this
    const percent = this.props.video.percent

    return (
      <GridItem
        props={this.props}
        toggleDeleteModal={this.toggleDeleteModal}
        toggleSelect={this.toggleSelect}
        toggleEmbedModal={this.toggleEmbedModal}
        percent={percent}
        group={this.props.group}
        onTitleChange={(title, force) => {
          this.editTitle(title, !force)
        }}
        onReorder={this.props.onReorder}
        isMobile={this.props.isMobile}
      >
        <div>
          <Modal
            isOpen={this.state.embedModalOpen}
            toggle={this.toggleEmbedModal}
            className="app-modal"
            title="Build Embed Code"
            darkMode={this.props.me.dark_mode}
          >
            <ModalBody>
              <EmbedMaker
                ref={(r) => {
                  self.embedMaker = r
                }}
                options={self.state.embedOptions}
                onChange={(opts) => {
                  self.setState({ embedOptions: opts, defaultsSaved: false })
                }}
                video={this.props.video}
              />
            </ModalBody>
            <ModalFooter>
              <ClipboardButton
                ref={(r) => {
                  self.embedButton = r
                }}
                component="button"
                className={`blue-button ${self.state.clipped ? 'clipped' : ''}`}
                option-text={() => getEmbedCode(self.props.video, self.state.embedOptions)}
                onSuccess={() => {
                  self.setState({ clipped: true })
                  self.embedMaker.select()
                  window.ga('send', 'event', 'Embeds', 'copied', 'dashboard_advanced')
                }}
                onError={() => self.embedMaker.select()}
              >
                {self.state.clipped ? 'Copied!' : 'Copy Embed Code'}
              </ClipboardButton>
            </ModalFooter>
          </Modal>
          <Modal
            isOpen={this.state.deleteModalOpen}
            toggle={this.toggleDeleteModal}
            className="app-modal"
            title="Delete Video"
            darkMode={this.props.me.dark_mode}
          >
            <ModalBody>
              Are you sure you want to delete{' '}
              {this.props.video ? this.props.video.title || 'this video' : 'this video'}
              ?
            </ModalBody>
            <ModalFooter>
              <button
                className="blue-button"
                onClick={() => {
                  this.toggleDeleteModal()
                  this.props.dispatch(deleteVideo(this.props.video))
                }}
              >Delete</button>
            </ModalFooter>
          </Modal>
        </div>
      </GridItem>
    )
  }
}

export default connect()(VideoItem)
